"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchPassenger = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const Autocomplete_1 = require("../Autocomplete/Autocomplete");
const SearchPassengerItem_1 = require("./SearchPassengerItem");
const SearchGroup = (props) => {
    const { group, onSelect } = props;
    const { label, items } = group;
    return (react_1.default.createElement(SearchPassengerItem_1.SearchPassengerItemGroup, { label: label }, items.map(item => (react_1.default.createElement(SearchPassengerItem_1.SearchPassengerItem, { key: item.id, onClick: () => onSelect(item), ...item })))));
};
const SearchPassenger = (props) => {
    const { className, items, onChange, onSelect, value, ...formFieldProps } = props;
    const classNames = (0, classnames_1.default)('search-passenger', className !== null && className !== void 0 ? className : '');
    const onChangeHandler = (0, react_1.useCallback)((e) => {
        onChange(e.target.value);
    }, [onChange]);
    return (react_1.default.createElement(Autocomplete_1.Autocomplete, { ...formFieldProps, className: classNames, onChange: onChangeHandler, value: value, addonWidth: '200px' }, items.filter(x => x.items.length !== 0).map((group, idx) => (react_1.default.createElement(SearchGroup, { key: idx, group: group, onSelect: onSelect })))));
};
exports.SearchPassenger = SearchPassenger;
//# sourceMappingURL=index.js.map